import {AppUser, Maybe} from "../types";

export const has_access_to_study = (user: Maybe<AppUser>) => {
    if (user) {
        return user.email.includes("@finauta.com");
    } else {
        return false;
    }
}


export const has_access_to_alpha = (user: Maybe<AppUser>) => {
    if (user) {
        return ['oscar@finauta.com', 'javier@finauta.com', 'emilio@finauta.com'].includes(user.email);
    } else {
        return false;
    }
}

export const has_access_to_beta = (user: Maybe<AppUser>) => {
    if (user) {
        return user.email != 'hola@finauta.com';
    } else {
        return false;
    }
}

export const has_access_to_deprecated = (user: Maybe<AppUser>) => {
    if (user) {
        return ['oscar@finauta.com', 'javier@finauta.com', 'emilio@finauta.com', "luis@finauta.com", "manuel@finauta.com", "victor@finauta.com"].includes(user.email);
    } else {
        return false;
    }
}